import * as React from 'react';
const SvgPlusKit = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1a1 1 0 00-1 1v5H2a1 1 0 100 2h5v5a1 1 0 102 0V9h5a1 1 0 100-2H9V2a1 1 0 00-1-1z"
            fill="currentColor"
        />
    </svg>
);
export default SvgPlusKit;
